webpackJsonp([0],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_View__ = __webpack_require__(482);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Core_View__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Core_Factories_ViewFactory__ = __webpack_require__(39);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Core_Factories_ViewFactory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Core_Helpers_Guid__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Directives_InitDirective__ = __webpack_require__(484);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Directives_InitDirective__["a"]; });




// Directives



/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Uri; });
var Uri = /** @class */ (function () {
    function Uri() {
    }
    Uri.getUri = function (name) {
        var uri = window.__URI[name];
        if (!uri) {
            throw "Could not find uri for " + name;
        }
        return uri;
    };
    return Uri;
}());



/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    registeredResidence: {
        other: { value: "7ef591e5-1c1c-484d-9ea7-7c5cc2ca8c4d" },
    },
    bank: {
        swedbank: { value: 1 },
        seb: { value: 2 },
        lhv: { value: 3 },
        coop: { value: 4 },
        luminor: { value: 5 },
        danske: { value: 6 }
    }
});


/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_xelect_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_xelect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_xelect_js__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var XelectComponent = /** @class */ (function (_super) {
    __extends(XelectComponent, _super);
    function XelectComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._oldValue = "";
        _this._shouldBlockChangeEvent = false;
        return _this;
    }
    XelectComponent.prototype.mounted = function () {
        var _this = this;
        var options = {
            name: this.name,
            allowEmpty: this.allowEmpty,
            multiselect: this.multiselect,
            readOnly: this.readOnly,
            labels: {
                hint: this.labelHint,
                searching: this.labelSearching,
                noResults: this.labelNotFound
            }
        };
        if (this.autocomplete) {
            options.type = "autocomplete";
            options.ac = {
                url: this.acUrl
            };
        }
        if (typeof this.forceValue !== "undefined") {
            options.forceValue = this.forceValue;
        }
        var node = this.$el.children[0];
        this._xelect = new __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_xelect_js___default.a(node ? node : this.$el, options);
        if (this.options.length) {
            this.onOptionsChange(this.options, []);
        }
        this._xelect.change(function (x) {
            if (_this._shouldBlockChangeEvent) {
                return;
            }
            if (x) {
                if (x.value == _this._oldValue) {
                    return;
                }
                _this.$emit('update-value', x.value, _this);
            }
            else if (!!_this._oldValue) {
                _this.$emit('update-value', undefined, _this);
            }
            _this._oldValue = x ? x.value : "";
        });
        this._xelect.onSelect(function () {
            var input = _this._xelect.el_input;
            if (input) {
                input.blur();
            }
        });
        this.$emit('update-instance', this._xelect);
    };
    XelectComponent.prototype.onOptionsChange = function (options, oldVal) {
        if (!this._xelect || !options) {
            return;
        }
        this._shouldBlockChangeEvent = true;
        var selectedValue = this._xelect.getSelectedItem();
        var isThereSelectedValue = false;
        var defaultValue = null;
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            if (selectedValue && option.value === selectedValue.value) {
                option.selected = true;
            }
            if (!option.value) {
                defaultValue = option;
            }
            isThereSelectedValue = isThereSelectedValue || Boolean(option.selected);
        }
        if (!isThereSelectedValue && defaultValue !== null) {
            defaultValue.selected = true;
        }
        this._xelect.clearOptions();
        this._xelect.addOptions(options);
        this._shouldBlockChangeEvent = false;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], XelectComponent.prototype, "allowEmpty", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], XelectComponent.prototype, "classList", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], XelectComponent.prototype, "multiselect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], XelectComponent.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], XelectComponent.prototype, "autocomplete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], XelectComponent.prototype, "forceValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], XelectComponent.prototype, "acUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: new Array() })
    ], XelectComponent.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], XelectComponent.prototype, "readOnly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], XelectComponent.prototype, "labelHint", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "..." })
    ], XelectComponent.prototype, "labelSearching", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], XelectComponent.prototype, "labelNotFound", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], XelectComponent.prototype, "instance", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], XelectComponent.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('options')
    ], XelectComponent.prototype, "onOptionsChange", null);
    XelectComponent = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], XelectComponent);
    return XelectComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (XelectComponent);


/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_CollapsibleBlock_ts__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31aec6e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapsibleBlock_vue__ = __webpack_require__(515);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_CollapsibleBlock_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31aec6e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapsibleBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\CollapsibleBlock\\CollapsibleBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31aec6e6", Component.options)
  } else {
    hotAPI.reload("data-v-31aec6e6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var CollapsibleBlock = /** @class */ (function (_super) {
    __extends(CollapsibleBlock, _super);
    function CollapsibleBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsibleBlock.prototype.data = function () {
        return {
            show: this.isOpen
        };
    };
    CollapsibleBlock.prototype.invert = function () {
        this._data.show = !this._data.show;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], CollapsibleBlock.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], CollapsibleBlock.prototype, "isOpen", void 0);
    CollapsibleBlock = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], CollapsibleBlock);
    return CollapsibleBlock;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (CollapsibleBlock);


/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var ValidationMessage = /** @class */ (function (_super) {
    __extends(ValidationMessage, _super);
    function ValidationMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ValidationMessage.prototype, "errors", {
        get: function () {
            var source = this.prop;
            if (this.path) {
                var segments = this.path.split(".");
                for (var i = 0; i < segments.length; i++) {
                    if (!source) {
                        break;
                    }
                    source = source[segments[i]];
                }
            }
            if (this.errorsKey && source) {
                source = source[this.errorsKey];
            }
            if (!source) {
                return [];
            }
            return source.errors;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], ValidationMessage.prototype, "prop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], ValidationMessage.prototype, "path", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], ValidationMessage.prototype, "errorsKey", void 0);
    ValidationMessage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], ValidationMessage);
    return ValidationMessage;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ValidationMessage);


/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewFactory; });
var ViewFactory = /** @class */ (function () {
    function ViewFactory() {
    }
    ViewFactory.setRegistry = function (registry) {
        this.ViewRegistry = registry;
    };
    ViewFactory.createView = function (name) {
        var view = this.ViewRegistry[name];
        if (!view) {
            throw "Could not find view: " + name;
        }
        return new view();
    };
    ViewFactory.ViewRegistry = {};
    return ViewFactory;
}());



/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
var View = /** @class */ (function () {
    function View() {
        this.setupEvents();
    }
    View.prototype.setupEvents = function () {
        var _this = this;
        document.addEventListener("DOMContentLoaded", function () {
            if (_this.$viewLoaded) {
                _this.$viewLoaded();
            }
        });
    };
    return View;
}());



/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Guid */
var Guid = /** @class */ (function () {
    function Guid() {
    }
    Guid.generate = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return Guid;
}());



/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitDirective; });
var InitDirective = /** @class */ (function () {
    function InitDirective() {
        this.bind = this.onBind;
    }
    InitDirective.prototype.onBind = function (el, binding, vnode, oldVnode) {
        var arg = binding.arg.split('-').map(function (arg, index) {
            return (index > 0) ? arg[0].toUpperCase() + arg.substring(1) : arg;
        }).join('');
        return (vnode.context || {})[arg] = binding.value;
    };
    return InitDirective;
}());



/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classList }, [
    _c("div", { staticClass: "xelect-wrap" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-395c4ea7", esExports)
  }
}

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collapsible" }, [
    _c(
      "div",
      { staticClass: "row collapsible__header", on: { click: _vm.invert } },
      [
        _c("div", {
          class:
            "col-xs-1 collapsible__slider " +
            (_vm.show ? "collapsible__slider--collapsed" : "")
        }),
        _vm._v(" "),
        _c("h4", { staticClass: "col-xs collapsible__header-text" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row collapsible__content" }, [
      _c(
        "div",
        { staticClass: "col-xs col-xs-offset-1 collapsible__content-text" },
        [_vm.show ? _vm._t("default") : _vm._e()],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31aec6e6", esExports)
  }
}

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errors
    ? _c(
        "div",
        { staticClass: "has-error" },
        _vm._l(_vm.errors, function(error) {
          return _c("div", [
            _vm._v("\n        " + _vm._s(error.error) + "\n    ")
          ])
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cccd80ac", esExports)
  }
}

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_ValidationMessage_ts__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cccd80ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationMessage_vue__ = __webpack_require__(534);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_ValidationMessage_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cccd80ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\ValidationMessage\\ValidationMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cccd80ac", Component.options)
  } else {
    hotAPI.reload("data-v-cccd80ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_js_modal__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_js_modal__);


var ModalHelper = /** @class */ (function () {
    function ModalHelper(context) {
        this._context = context;
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_js_modal___default.a, { dialog: true });
    }
    ModalHelper.prototype.hide = function () {
        this._context.$modal.hide("dialog");
    };
    ModalHelper.prototype.getModal = function (options) {
        this._context.$modal.show("dialog", options);
    };
    ModalHelper.prototype.getConfirmModal = function (action, data, text) {
        var _this = this;
        this.getModal({
            title: "Kinnitus",
            text: text,
            buttons: [
                {
                    title: 'Jah',
                    handler: function () {
                        action(data);
                        _this.hide();
                    }
                },
                {
                    title: 'Ei',
                    default: true,
                    handler: function () {
                        _this.hide();
                    }
                }
            ]
        });
    };
    ModalHelper.prototype.getNotificationModal = function (title, text) {
        var _this = this;
        this.getModal({
            title: title,
            text: text,
            buttons: [{
                    title: "OK",
                    handler: function () {
                        _this.hide();
                    }
                }]
        });
    };
    return ModalHelper;
}());



/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_XelectComponent_ts__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395c4ea7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XelectComponent_vue__ = __webpack_require__(509);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_XelectComponent_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395c4ea7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XelectComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\Xelect\\XelectComponent.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-395c4ea7", Component.options)
  } else {
    hotAPI.reload("data-v-395c4ea7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// js/common.bundle.js